
import carpetaImg from '../assets/carpeta.png'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

function ItemCarpeta({ texto }) {

    const { actualizarCarpeta } = useEmpleadoStore()


    return (
        <>
            <div className='card-carpetas' onClick={()=> actualizarCarpeta(texto) }>
                <img src={carpetaImg} alt='carpeta'/>
                <p>{texto}</p>
            </div>
        </>
    )
}

export default ItemCarpeta
